import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'
import RemainingCampaignImpressionsBudgetFields from './RemainingCampaignImpressionsBudgetFields'

import { IMPRESSIONS } from '../../../Google/UploadGoogleAdCreative/UploadGoogleAdCreativeForm/CampaignForm/fields'

import useDrawerFormStyles from '../../../../styles/common/drawerForms'

const ImpressionsBudgetSection = ({ formik, remainingImpressions, showPacing }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  return (
    <div className={drawerFormClasses.subSection}>
      <FieldLabelWrapper label={t('Impressions')} labelFor={IMPRESSIONS}>
        <RemainingCampaignImpressionsBudgetFields
          formik={formik}
          remainingImpressions={remainingImpressions}
          showPacing={showPacing}
        />
      </FieldLabelWrapper>
    </div>
  )
}

export default ImpressionsBudgetSection
